import React, { useEffect } from "react";
import useEditDataGroup from "./edit-data-group.hooks";
import { Button, Col, Row, Select } from 'antd';
import { t } from 'i18next';
import MSSDepot from '../../../../component/select/MSSDepot';
import { useState } from 'react';
import { useSelector } from 'react-redux';

const TabSetDataScope = ({ setFlag, loading, depotListCount, depotIdList, onSelected, depotList, setDepotList }) => {
  

  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );

  const getDepot = (value) => {
    let vals = value?.data.map((el) => el.id);
    setDepotList((prevsValue) => {
      return {
        ...value
      };
    });
  };
  return (
    <>
      <Row className='mt-5'>
        <Col span={12}>
          <div className='mt-2'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("DATA_GROUP:LBL_DEPOT_ID")}
            </p>
            <div className={`w-[528px]`}>
              <MSSDepot
                setFlag={setFlag}
                token={token}
                getValue={(value) => getDepot(value)}
                level={1}
                isEdit={loading}
                isSelectAll={depotList.flagCheckAll}
                currentValue={
                  depotList?.data?.length !== 0 &&
                    depotList?.data !== undefined
                    ? depotList?.data.map((el) => el.value)
                    : undefined
                }
                value={depotList}
                // error={this.state.error}
                errorNamespace={"depot"}
                onSelected={onSelected}
              />
            </div>
            {/* <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${depotListError ? `visible` : `hidden`}`}>This field is required</p> */}


          </div>
        </Col>
        <Col span={12}></Col>
      </Row>
    </>
  )
};

export default TabSetDataScope;
